import { Color, FormItem, Link, Text } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'

import { getBillTransactionsQueries } from '@features/bills/utils/getBillTransactionsQueries'
import { useTransactionView } from '@features/transactions/contexts/transactionViewContext'

import { fetchTransactions } from '../../../../../transactions'
import { useBillView } from '../../contexts/billViewContext'
import * as Styled from './styles'

export const BillTransactions = (): ReactElement => {
  const { t } = useTranslation()
  const { billId } = useBillView()
  const { handleTransactionClick } = useTransactionView()

  const { queryKey, queryProps } = useMemo(() => getBillTransactionsQueries(billId), [billId])

  const { data, isLoading } = useQuery(queryKey, () => fetchTransactions(queryProps))
  const transactions = data?.transactions || []

  return (
    <FormItem label={t('transactions')} labelAlignment="right">
      {isLoading ? (
        <Styled.SkeletonText width={75} />
      ) : (
        <Text alignment="right">
          {transactions.length > 0 ? (
            transactions.map((transaction, index) => {
              const { id, transactionNo, isVoid, isVoided } = transaction
              const isLastTransaction = index === transactions.length - 1
              return (
                <Text key={id} inline as="span">
                  <Text
                    color={isVoid || isVoided ? Color.Grey500 : Color.Black}
                    onClick={() => handleTransactionClick(transaction)}
                    as="span"
                    inline
                  >
                    <Link withAnimation>{transactionNo?.toString()}</Link>
                  </Text>
                  {!isLastTransaction && <Text inline>, </Text>}
                </Text>
              )
            })
          ) : (
            <Text>—</Text>
          )}
        </Text>
      )}
    </FormItem>
  )
}
